import { cancelar_matricula } from "./cancelar-matricula/cancelar-matricula";
import { reativar_matricula } from "./reativar-matricula/reativar-matricula";
import { deixou_de_frequentar } from "./deixou-de-frequentar/deixou-de-frequentar";
import { nunca_frequentou } from "./nunca-frequentou/nunca-frequentou";
import { matricula_errada } from "./matricula-errada/matricula-errada";

const manutencao_matricula = [
  cancelar_matricula,
  deixou_de_frequentar,
  reativar_matricula,
  nunca_frequentou,
  matricula_errada,
];

export { manutencao_matricula };
